<template>
    <div class="aboutUs_wrap">
      <Header/>
      <section class="warp">
        <div class="title">
          <span class="line_left line">
            <img :src="leftImg">
          </span>
          <h3>关于我们</h3>
          <span class="line_right line">
            <img src="../assets/goldRight.png">
          </span>
        </div>
        <div class="content">
          <p>
            盈融达投资（北京）有限公司，创立于2006年，注册资本：RMB 3000万，盈融达投资专注于资产管理以及投资咨询服务，为客户提供资产管理和财务增值服务；
            盈融达投资，运用专业的分析，通过对各种规范的金融品种的投资，在各种市场环境中，为客户资产实现保值增值，
            盈融达投资，致力于成为能够代表特有市场风格的私募基金管理公司； 团队是公司的核心竞争力。盈融达建立了完整的金融工程、研究、投资和风险管理团队，具有出色的市场分析和调查研究能力。
          </p>
        </div>
      </section>
      <Footer style="10%"/>
    </div>
</template>
<script>
  import Header from './header'
  import leftImg from '../assets/goldLeft .png'
  import Footer from './footer'
    export default {
        name: 'aboutUs',
        components: {
          Header,
          Footer
        },

        props: {},

        data() {
            return {
              leftImg,
            }
        },

        computed: {},

        watch: {},

        created() {
        },

        mounted() {
        },

        destroyed() {
        },

        methods: {}
    }
</script>

<style scoped lang="scss">
.aboutUs_wrap{
  height: 100%;
    .warp{
      padding-top: 5.625rem;
      height: 80%;
      width: 40%;
      margin: auto;
      .title{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        text-align: center;
        position: relative;
      .line_left,.line_right{
        display: inline-block;
        position: absolute;
        top: 50%;
      }
      .line{
        width: 75px;
        height: 20px;
        line-height: 20px;
        margin-top: -10px;
      }
      h3{
        display: inline-block;
        color: #555;
        text-align: center;
      }
      img{
        width: 100%;
        vertical-align: middle;
      }
      }
      .content{
        color: #666;
        text-align: justify;
      }
    }
}
@media screen and (min-width: 768px) {
  .line_left{
    left: 60px;
  }
  .line_right{
    right: 60px;
  }
  .line{
    width: 75px;
    height: 20px;
    line-height: 20px;
    margin-top: -10px;
  }
  h3{
    font-size: 30px;
    margin: 70px 50px;
  }

  .content{
    text-align: justify;
    -ms-text-justify: inter-ideograph;
    text-justify: inter-ideograph;
    text-spacing: ideograph-alpha;
    font-size: 14px;
    line-height: 32px;
    text-indent: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue